import { Outlet } from 'react-router-dom';
import HeaderB2C from './HeaderB2c';
import Footer from '../../shared/layout/Footer';

type LayoutProps = { logo: string };

const LayoutB2c = ({ logo }: LayoutProps) => {
  return (
    <div className="text-zinc-700">
      <HeaderB2C logo={logo} />
      <div className="outlet p-2">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default LayoutB2c;
